import React from 'react';

class SignaturePad extends React.Component {
    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.state = {
            drawing: false,
            lastX: 0,
            lastY: 0,
        };
    }

    componentDidMount() {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        canvas.addEventListener("mousedown", this.handleMouseDown);
        canvas.addEventListener("mousemove", this.handleMouseMove);
        canvas.addEventListener("mouseup", this.handleMouseUp);
        canvas.addEventListener("mouseleave", this.handleMouseUp);

        canvas.addEventListener("touchstart", this.handleTouchStart, { passive: false });
        canvas.addEventListener("touchmove", this.handleTouchMove, { passive: false });
        canvas.addEventListener("touchend", this.handleMouseUp);
    }

    handleMouseDown = (e) => {
        const rect = e.target.getBoundingClientRect();
        this.setState({
            drawing: true,
            lastX: e.clientX - rect.left,
            lastY: e.clientY - rect.top,
        });
        if (this.props.onStart) this.props.onStart();
    };

    handleMouseMove = (e) => {
        if (!this.state.drawing) return;
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext("2d");
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        ctx.beginPath();
        ctx.moveTo(this.state.lastX, this.state.lastY);
        ctx.lineTo(x, y);
        ctx.stroke();
        this.setState({ lastX: x, lastY: y });
        if (this.props.onDraw) this.props.onDraw();
    };

    handleMouseUp = () => {
        this.setState({ drawing: false });
        if (this.props.onEnd) this.props.onEnd();
    };

    handleTouchStart = (e) => {
        e.preventDefault();
        const rect = e.target.getBoundingClientRect();
        const touch = e.touches[0];
        this.setState({
            drawing: true,
            lastX: touch.clientX - rect.left,
            lastY: touch.clientY - rect.top,
        });
        if (this.props.onStart) this.props.onStart();
    };

    handleTouchMove = (e) => {
        e.preventDefault();
        if (!this.state.drawing) return;
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext("2d");
        const rect = canvas.getBoundingClientRect();
        const touch = e.touches[0];
        const x = touch.clientX - rect.left;
        const y = touch.clientY - rect.top;
        ctx.beginPath();
        ctx.moveTo(this.state.lastX, this.state.lastY);
        ctx.lineTo(x, y);
        ctx.stroke();
        this.setState({ lastX: x, lastY: y });
        if (this.props.onDraw) this.props.onDraw();
    };

    clear = () => {
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (this.props.onClear) this.props.onClear();
    };

    getDataUrl = () => {
        return this.canvasRef.current.toDataURL();
    };

    render() {
        const { width = 500, height = 300, style = {} } = this.props;
        return (
            <canvas
                ref={this.canvasRef}
                width={width}
                height={height}
                style={{ border: '2px solid', cursor: 'crosshair', ...style }}
            />
        );
    }
}

export default SignaturePad;